module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "sprite-72169aba3aaebb7b19ede7951c92022d.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }